<template>
  <div class="pageContent mobileRecharge">
    <LoadingModal bgcolor="transparent" />
    <div v-show="!$store.state.pageLoading">
      <Top :title="name" :message="tips" />
      <div
        class="pageBigRadius pageCarServeShadow phone"
        v-if="cardDetailData != null"
      >
        <div class="pageFlexBetween pageFontWeight phoneType">
          <p>
            <img :src="cardDetailData.cardType === 0 ? shIcon : syIcon" alt />
            <span class="name">{{
              cardDetailData.cardType === 0 ? "中国石化" : "中国石油"
            }}</span>
          </p>
          <router-link :to="'/cardList'">
            <span class="update">更换</span>
          </router-link>
        </div>
        <div class="phoneNum">
          <p>
            {{
              cardDetailData.cardNum
                ? cardDetailData.cardNum.replace(/(.{4})/g, "$1 ")
                : ""
            }}
          </p>
          <p class="name">姓名：{{ cardDetailData.cardHolder }}</p>
        </div>
      </div>
      <div
        class="pageBigRadius pageCarServeShadow phone"
        v-if="cardDetailData == null"
        @click="$push({ path: '/addCard' })"
      >
        <div class="addcard"><van-icon name="plus" />添加油卡</div>
      </div>
      <VTitle val="请选择面值" :showLine="false" />
      <TypeList
        :list="selList"
        :activeIndex="selItem"
        @selItem="handleSel"
        :canSel="canSel"
        :isMember="isMember"
        :vip_discount="vip_discount"
      />
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        :sellData="sellData"
        :isOilCard="isCheck"
        :tips="time_tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="1"
        :params="params"
        :balance="balance"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
      />
      <!-- <Tips>
        <div slot="content">
          <ul
            style="
              list-style: disc;
              color: #000;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <p>
                中国石化加油卡系统将于9月8日-14日进行升级切换，期间充值服务暂停办理，不便之处，敬请谅解。
              </p>
            </li>
          </ul>
        </div>
      </Tips> -->
    </div>
  </div>
</template>
<script>
import { getDefalutCard, getProductList, getOilCardList } from "api/onLine";
import Tips from "server/data/tips.json";
export default {
  props: {
    name: String,
    cid: Number,
    balance: Number,
    couponsDeduct: Number,
    isMember: Boolean,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cardNumber: "",
      shIcon: require("assets/sh.png"),
      syIcon: require("assets/sy.png"),
      cardDetailData: {},
      // 数据列表
      selListDefaultData: [],
      selList: [],
      selItem: null,
      canSel: false, // 整个列表是否可选
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      isCheck: true,
      time_tips: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      ident: "",
      params: { account: "" },
      vip_discount: 0,
    };
  },
  created() {
    this.$store.commit("setPageLoading", true);
    this.selListDefaultData = require("server/data/oilCardRecharge.json");
    this.selList = this.selListDefaultData.list;
    this.tips = Tips.tips.oilRecharge;
    this.describe = Tips.describe.oilRecharge;
  },
  mounted() {
    this.ident = this.$route.query.ident;
    this.loadData();
  },
  methods: {
    handleSel(i) {
      this.isCheck = true;
      this.selItem = i;
      this.discount = this.selList[i].discount;
      this.sellData = {
        ...this.selList[i],
        sell_price: Number(this.selList[i].productDenomination),
      };
      this.params.productNo = this.selList[i].productNo;
    },
    loadData() {
      getOilCardList().then((res) => {
        if (res.status == 200) {
          if (res.data.length > 0) {
            let arry = res.data.find((item) => item.cardIsDefault == 1);
            if (arry != undefined) {
              this.cardDetailData = arry;
              this.params.account = arry.cardNum;
              this.getServeList(arry.cardType == 0 ? "zsh" : "zsy");
            } else {
              // this.getServeList();
              this.cardDetailData = null;
              this.selList = this.selListDefaultData.list;
            }
          } else {
            this.cardDetailData = null;
          }
          this.$nextTick(() => {
            this.$store.commit("setPageLoading", false);
          });
          // if (Object.keys(res.data).length === 0) {
          //   this.getServeList(27); // 没有卡时获取默认的服务列表
          // } else {
          //   this.getServeList(res.data.model.service_class_id);
          // }
        } else {
          this.$error(res.message);
        }
      });
    },
    getServeList(label) {
      getProductList(label, this.mouldId).then((res) => {
        if (res.status === 200) {
          this.selList = res.data;
          this.canSel = true;
        } else {
          this.selList = this.selListDefaultData.list;
          this.canSel = false;
          this.selItem = null;
          this.sellData = { sell_price: -1 };
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
        });
      });
    },
    handleClearMobile() {
      this.mobile = null;
    },
  },
};
</script>

<style scoped lang="less">
.mobileRecharge {
  .phone {
    margin-top: 10px;
    padding: 10px 12px;
    box-sizing: border-box;
    background: #fff;
    .addcard {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 3.1;
    }
    .phoneType {
      .name {
        font-size: 15px;
        color: initial;
        font-weight: 700;
      }
      .update {
        color: #aaaaaa;
        font-size: var(--pFont);
        font-weight: 400;
      }
      p {
        display: flex;
        align-items: center;
        span {
          color: var(--hidColor);
          font-weight: normal;
        }
        img {
          width: 25px;
        }
      }
      a {
        color: initial;
      }
    }
    .phoneNum,
    .phoneInput {
      font-weight: 900;
      font-size: 20px;
      color: var(--redColor);
      span {
        color: #7f7f7f;
        font-size: var(--middleFont);
        font-weight: initial;
      }
      .name {
        font-size: 14px;
        color: #7f7f7f;
        font-weight: initial;
      }
    }
    .phoneInput {
      padding: 0;
      /deep/ .van-field__control {
        color: var(--redColor);
      }
    }
  }
}
</style>
